import React, { Component } from "react";
import "./Landing.css";
import withTheme from "@material-ui/core/styles/withTheme";
import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
// import imageBackground from "../img/hero3.png"
//import imageBackgroundPortrait from "../img/hero_potrait.png"


import imageBackgroundPortrait from "../img/background-images-2025-portrait.jpg"

import imageBackground from "../img/background-images-2025.jpg"
@inject("userStore", "commonStore")
@withRouter
@observer
class Splash extends Component {
    
    render() {
         const isPortrait = window.matchMedia('(orientation: portrait)').matches;

         const landingStyle = {
            backgroundColor: '#000000',
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% 100%', // Equivalent to contain in this context
            minHeight: '100vh',
            backgroundImage: isPortrait ? `url(${imageBackgroundPortrait})` : `url(${imageBackground})`, // Set portrait image conditionally
        };
        return <div style={landingStyle} className="Landing" />;
    }
}

export default withTheme()(Splash);
